var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":_vm.$helpers.getRedirectUrl(_vm.lender, 'list-text-toplist', _vm.position),"target":"_blank","rel":"nofollow"}},[_c('span',[_vm._v(_vm._s(_vm.lender.data.title))]),_vm._v(": "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }